import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectedList"]

  connect() {
    this.selectedCompetencies = []
    this.updateSelectedList()
    
    // Finde den "Alle hinzufügen" Button und füge Event Listener hinzu
    const button = this.element.querySelector('[data-action*="addAllCompetencies"]')
    if (button) {
      button.addEventListener('click', (e) => {
        this.addAllCompetencies(e)
      })
    }
  }

  addToSelection(event) {
    const select = event.target
    const selectedOptions = Array.from(select.selectedOptions)
    
    selectedOptions.forEach(option => {
      const competencyId = option.value
      const competencyTitle = option.textContent.trim()
      
      if (competencyId && competencyId !== '' && !this.selectedCompetencies.some(c => c.id === competencyId)) {
        this.selectedCompetencies.push({
          id: competencyId,
          title: competencyTitle
        })
      }
    })
    
    this.updateSelectedList()
  }

  removeFromSelection(event) {
    const competencyId = event.target.dataset.competencyId
    this.selectedCompetencies = this.selectedCompetencies.filter(c => c.id !== competencyId)
    this.updateSelectedList()
  }

  updateSelectedList() {
    if (!this.hasSelectedListTarget) return

    const list = this.selectedListTarget
    list.innerHTML = ''

    this.selectedCompetencies.forEach(competency => {
      const item = document.createElement('div')
      item.className = 'flex items-center justify-between p-2 bg-blue-50 rounded-md mb-2'
      item.innerHTML = `
        <span class="text-sm">${competency.title}</span>
        <button type="button" 
                class="text-red-500 hover:text-red-700 ml-2"
                data-competency-id="${competency.id}"
                data-action="click->competency-requirements#removeFromSelection">
          <i class="fas fa-times"></i>
        </button>
      `
      list.appendChild(item)
    })
  }

  addAllCompetencies(event) {
    event.preventDefault()
    
    if (this.selectedCompetencies.length === 0) {
      alert('Bitte wählen Sie mindestens eine Kompetenz aus.')
      return
    }

    const requisitionId = this.getRequisitionId()
    
    const url = `/backend/requisitions/${requisitionId}/competency_requirements`

    const formData = new FormData()
    this.selectedCompetencies.forEach(competency => {
      formData.append('competency_requirement[competency_id][]', competency.id)
    })

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        return response.text().then(text => {
          throw new Error('Request failed')
        })
      }
    })
    .then(responseText => {
      // Response processed
    })
    .catch(error => {
      // Fetch error
    })

    // Leere die Auswahl nach dem Hinzufügen
    this.selectedCompetencies = []
    this.updateSelectedList()
  }

  getRequisitionId() {
    const urlParts = window.location.pathname.split('/')
    const requisitionIndex = urlParts.indexOf('requisitions')
    if (requisitionIndex !== -1 && urlParts[requisitionIndex + 1]) {
      const id = urlParts[requisitionIndex + 1]
      return id
    }
    return null
  }
}